import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { setNewForm } from 'apps/auth/actions/formAction';
import BaseLayout from 'apps/auth/components/common/Layout/BaseLayout';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { MainColumn } from 'apps/auth/components/common/Layout/MainColumn/MainColumn';
import { StubPage } from 'apps/auth/components/common/Layout/StubPage';
import { getField } from 'apps/auth/components/form-multi/utils';
import GaStatusFailed from 'apps/auth/components/ga/status/GaStatusFailed';
import GaStatusSuccess from 'apps/auth/components/ga/status/GaStatusSuccess';
import GaStatusWaiting from 'apps/auth/components/ga/status/GaStatusWaiting';
import BasePage from 'apps/auth/components/utils/BasePage';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { SMS_ON_SUCCESS_PAY_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_GA_POCKET, AUTH_PAY_NOTIFICATION_ACTION } from 'apps/auth/constants/UrlConstants';
import { useExtra, usePageMessages } from 'apps/auth/hooks/selectors';

const GaStatusPage = (props) => {
    const { sendPhonePlaceholder, sendTextPlaceholder, sendTextText, error_title, error_description, additional_check_button, cancelText } = usePageMessages();
    const { special_error_code, payStatus: status, gaServerNotAvailable, show_additional_check_button, pocketId } = useExtra();

    useEffect(() => {
        if (props.data.smsOnSuccessPay) {
            props.setNewForm(
                SMS_ON_SUCCESS_PAY_FORM_NAME,
                {
                    id: getField('id', props.data.smsOnSuccessPay.id, null, true, false),
                    phone: getField('phone', '', null, true, false, sendPhonePlaceholder, 'tel'),
                    text: getField('text', sendTextText, null, true, false, sendTextPlaceholder, 'text'),
                },
                AUTH_PAY_NOTIFICATION_ACTION,
            );
        }
    }, []);

    if (gaServerNotAvailable && props?.stateOptions?.isGA) {
        return (
            <MainColumn>
                <StubPage />
            </MainColumn>
        );
    } else if (special_error_code) {
        return (
            <InfoPage
                animatedIconFail
                headerText={error_title}
                secondaryText={error_description}
                primaryButtonType="reactLink"
                primaryButtonCaption={show_additional_check_button ? additional_check_button : ''}
                primaryButtonLink={`/auth/user-error?code=${special_error_code}`}
                topButtonCaption={cancelText}
                topButtonType="link"
                topButtonLink={`${AUTH_GA_POCKET}${pocketId}`}
            />
        );
    } else {
        return (
            <BaseLayout>
                {status && status.status > STATUS_OK && <GaStatusFailed />}
                {status && status.status === STATUS_OK && (
                    <GaStatusSuccess smsOnSuccessPay={props.data.smsOnSuccessPay} showSendSMSNotificationBlock={status.showSendSMSNotificationBlock} />
                )}
                {(!status || status.status < STATUS_OK) && (
                    <GaStatusWaiting
                        smsOnSuccessPay={props.data.smsOnSuccessPay}
                        showSendSMSNotificationBlock={status.showSendSMSNotificationBlock}
                        status={status}
                    />
                )}
            </BaseLayout>
        );
    }
};
export default connect(null, { setNewForm })(BasePage(GaStatusPage));
